export default __webpack_public_path__ + "static/media/dev-reactjs.d6d9a8e5.png";